import React, { FC }                   from 'react';
import { Icon, Message, MessageProps } from 'semantic-ui-react';

export const InfoMessage: FC<MessageProps> = ( props ) => (
	<Message className='fade-in' color={ 'blue' } { ...props }>
		<Message.Content>{ props.children }</Message.Content>
	</Message>
);
